module.exports = __webpack_public_path__ + "img/star-disabled.f7c2a740.png";